module.exports = __webpack_public_path__ + "img/teutoniques.d9221033.jpg";